var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 65,
    viewBox: "0 0 182 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4049 40.5193H0V27.2341H8.82519V7.56627C8.82519 5.80651 9.51737 4.11883 10.7495 2.87449C11.9816 1.63015 13.6526 0.931091 15.3951 0.931091H59.7122V14.2015H21.96V33.8842C21.96 35.6414 21.2699 37.3268 20.041 38.5707C18.812 39.8146 17.1448 40.5154 15.4049 40.5193Z",
    fill: "#004E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7573 0H77.6176V38.5038H90.7573V0Z",
    fill: "#004E5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.925 25.3672H136.785V65H149.925V25.3672Z",
    fill: "#004E5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182 38.4941H168.86V14.2015H110.192V0.931091H175.43C177.173 0.931091 178.844 1.63015 180.076 2.87449C181.308 4.11883 182 5.80651 182 7.56627V38.4941Z",
    fill: "#004E5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.37 63.1382H52.7058C50.9634 63.1382 49.2923 62.4392 48.0602 61.1948C46.8281 59.9505 46.136 58.2628 46.136 56.503V25.3672H59.2757V49.8679H109.824V25.3672H122.964V56.503C122.964 57.3765 122.793 58.2413 122.462 59.0479C122.13 59.8546 121.644 60.5871 121.031 61.2036C120.419 61.8201 119.691 62.3083 118.891 62.6403C118.092 62.9723 117.235 63.1415 116.37 63.1382Z",
    fill: "#004E5E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cd5d66c77a401f7fa84b192f65eea8c7.svg";
export { ForwardRef as ReactComponent };